import { createTheme } from "@mui/material/styles";



 const FarmasisTheme=createTheme({

 	palette: {
   		mode: 'light',
    	primary: {
      		main: '#09b5c1',
      		contrastText: '#ffebee',
    	}
  },
    typography: {
      fontFamily: ['Poppins', 'sans-serif'].join(",")
    }

 })


 export default FarmasisTheme